import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance"

export const changeSubscription = (id: number, isSubscribeAction?: boolean) => {
    const payload = { action_type: isSubscribeAction ? "opt-in" : "opt-out" }

    return axiosPrivate.post(
        `/dashboard/api/v1/merchant-statement/services/${id}/change-subscription`,
        payload
    )
}